"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFormSection = void 0;
const flattenAeSchema_1 = require("./helpers/flattenAeSchema");
const sortByOrder_1 = require("./helpers/sortByOrder");
const DefaultSubsections = require("./helpers/defaultSubsections");
const NO_TITLE = 'no_title';
/**
 * Generates a section based on a form
 * @param {FormSchema} formSchema The schema for the form.
 * @param {SectionDefinitionOptions=} options The options for this section.
 *
 * @returns {FormSectionSchema | null} Returns null when an action with no renderable data is passed in.
 */
function buildFormSection(section, formSchema) {
    var _a;
    const { options } = section;
    const header = ((_a = formSchema === null || formSchema === void 0 ? void 0 : formSchema.localization) === null || _a === void 0 ? void 0 : _a[(options === null || options === void 0 ? void 0 : options.language) || 'en']) ||
        formSchema.schema.title ||
        NO_TITLE;
    const language = (options === null || options === void 0 ? void 0 : options.language) || 'en';
    let subsections = [];
    if (!(formSchema === null || formSchema === void 0 ? void 0 : formSchema.schema))
        throw new Error('Formschema passed to buildFormSection is invalid');
    Object.keys(formSchema.schema).forEach((propertyKey) => {
        const propertyColumns = (0, flattenAeSchema_1.flattenAeSchema)(formSchema.schema, [propertyKey], options);
        subsections = subsections.concat(propertyColumns);
    });
    if (options === null || options === void 0 ? void 0 : options.sortAlphabetically) {
        subsections.sort((a, b) => a.subtitle.localeCompare(b.subtitle, language, { numeric: true }));
    }
    else {
        subsections.sort((a, b) => (0, sortByOrder_1.sortByOrder)(a, b, formSchema));
    }
    if (!subsections.length && !(options === null || options === void 0 ? void 0 : options.showIfEmpty)) {
        console.warn("Form section is empty and won't be rendered");
        return null;
    }
    return {
        type: 'form',
        title: header,
        form: formSchema._id.toString(),
        description: section.description || `Form section (${header})`,
        subsections: [
            DefaultSubsections.patientID(),
            DefaultSubsections.submissionID(),
            ...subsections,
            DefaultSubsections.created_at(),
        ],
    };
}
exports.buildFormSection = buildFormSection;
//# sourceMappingURL=formSection.js.map